import {
  Space,
  Button,
  AutoComplete,
  DatePicker,
  Divider,
  Slider,
  InputNumber,
  Input,
} from "antd";
import { ColumnType } from "antd/lib/table";
import React from "react";
import { SearchOutlined } from "@ant-design/icons";
import { ColumnsProps } from "../components/TableComponents/DynamicTableFix/DynamicTable";
import moment, { Moment } from "moment";
import "moment/locale/th";
import SearchTextInTable from "../components/TableComponents/DynamicTableFix/SearchTextInTable";
import { FilterValue } from "antd/lib/table/interface";
import StringFilterComponent from "../components/TableComponents/DynamicTableV3/FilterBody/StringFilterComponent";
import NumberFilterComponent from "../components/TableComponents/DynamicTableV3/FilterBody/NumberFilterComponent";
import DataFilterComponent from "../components/TableComponents/DynamicTableV3/FilterBody/DataFilterComponent";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
const { RangePicker } = DatePicker;
export const getColumnSearchProps = (
  colProp: ColumnsProps,
  dataSource: any[],
  filterState: Record<string, FilterValue | null>,
  allColumnProps: ColumnsProps[]
): ColumnType<any> => {
  if (colProp.type === "date" || colProp.type === "datetime") {
    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <div
            style={{
              padding: 5,
              gap: 5,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <RangePicker
              value={selectedKeys[0] as any}
              ranges={{
                Today: [moment().add(543, "year"), moment().add(543, "year")],
                "This Month": [
                  moment().add(543, "year").startOf("month"),
                  moment().add(543, "year").endOf("month"),
                ],
                "This Year": [
                  moment().add(543, "year").startOf("year"),
                  moment().add(543, "year").endOf("year"),
                ],
              }}
              format={"DD MMM YYYY"}
              defaultPickerValue={[
                moment().add(543, "year"),
                moment().add(543, "year"),
              ]}
              onChange={(e) => {
                if (e) {
                  setSelectedKeys([e as any]);
                } else {
                  clearFilters && clearFilters();
                }
              }}
            />
            <div
              className="ant-table-filter-dropdown-btns"
              style={{ padding: 5 }}
            >
              <Button
                onClick={() => clearFilters && clearFilters()}
                size="small"
                disabled={selectedKeys.length === 0}
                type="link"
              >
                Reset
              </Button>
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  confirm({ closeDropdown: true });
                }}
              >
                Ok
              </Button>
            </div>
          </div>
        );
      },
      onFilter: (value, record) => {
        const selectedVal: Moment[] = value as any;
        const rowData: Moment = record[colProp.key];
        if (!rowData) return false;
        if (colProp.type === "date") {
          return rowData
            .add(1, "seconds")
            .isBetween(
              selectedVal[0].startOf("day"),
              selectedVal[1].endOf("day")
            );
        } else {
          return rowData.isBetween(
            selectedVal[0].startOf("day"),
            selectedVal[1].endOf("day")
          );
        }
      },
    };
  } else if (colProp.type === "number") {
    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        const optionValue: any = colProp.option.map((option) => {
          return option ? Number(option?.replaceAll(",", "")) : 0;
        });

        const val: [number, number] = selectedKeys[0] as any;

        const minOption = Math.min(...optionValue);
        const maxOption = Math.max(...optionValue);
        const minVal = val ? val[0] : minOption;
        const maxVal = val ? val[1] : maxOption;

        const decimal = colProp.decimal ?? 2;
        const decimalStep = Math.pow(10, -decimal);
        return (
          <div
            style={{
              padding: 5,
              gap: 5,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              width: 300,
              textAlign: "center",
            }}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <Slider
              range
              defaultValue={[0, maxOption]}
              value={[minVal, maxVal]}
              step={decimalStep}
              min={minOption === maxOption ? 0 : minOption}
              max={maxOption}
              onChange={(e) => {
                setSelectedKeys([e as any]);
              }}
            />
            <div
              style={{
                padding: 5,
                gap: 5,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
              }}
            >
              <InputNumber
                min={minOption}
                max={maxOption}
                style={{ margin: "0 16px" }}
                value={minVal}
                step={decimalStep.toString()}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                stringMode
                controls={false}
                onChange={(e) => {
                  if (e) {
                    setSelectedKeys([[Number(e), maxVal] as any]);
                  }
                }}
              />
              -
              <InputNumber
                min={minOption}
                max={maxOption}
                style={{ margin: "0 16px" }}
                controls={false}
                value={maxVal}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                step={decimalStep.toString()}
                stringMode
                onChange={(e) => {
                  if (e) {
                    setSelectedKeys([[minVal, Number(e)] as any]);
                  }
                }}
              />
            </div>
            <div
              className="ant-table-filter-dropdown-btns"
              style={{ padding: 5 }}
            >
              <Button
                onClick={() => clearFilters && clearFilters()}
                size="small"
                disabled={selectedKeys.length === 0}
                type="link"
              >
                Reset
              </Button>
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  confirm({ closeDropdown: true });
                }}
              >
                Ok
              </Button>
            </div>
          </div>
        );
      },
      onFilter: (value: any, record) => {
        const recordVal = Number(record[colProp.key]);

        return recordVal >= value[0] && recordVal <= value[1];
      },
    };
  } else if (colProp.type === "string") {
    return {
      filterDropdown: (filterDropDownProps) => {
        return (
          <div
            style={{
              padding: 5,
              gap: 5,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <SearchTextInTable
              colProp={colProp}
              option={colProp.option}
              filterDropDownProps={filterDropDownProps}
              columnLabel={colProp.label}
              filterState={filterState}
              dataSource={dataSource}
              allColumnProps={allColumnProps}
            />
            <div
              className="ant-table-filter-dropdown-btns"
              style={{ padding: 5 }}
            >
              <div></div>
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  filterDropDownProps.confirm({ closeDropdown: true });
                }}
              >
                Ok
              </Button>
            </div>
          </div>
        );
      },
      onFilter: (value, record) => {
        if (typeof value === "string") {
          return (
            record[colProp.key]?.toString().toLowerCase() ===
            (value as string).toString()?.toLowerCase()
          );
        } else {
          return record[colProp.key] == value.toString();
        }
      },
    };
  } else {
    return { sorter: false };
  }
};

export const filterData = (
  data: any[],
  filters: { [x: string]: any },
  colProps?: ColumnsProps[],
  colProp?: ColumnsProps
) => {
  return data.filter((item: any) => {
    return Object.keys(filters).every((key) => {
      const filter = filters[key];
      const _colProp = colProp
        ? colProp
        : colProps?.find((col) => col.key === key);

      const cellData = item[key];

      if (!filter?.value) return true;
      if (!_colProp) return true;

      switch (filter.matchMode) {
        case "in": {
          const { searchText, checkedList } = filter.value || {};

          const checkedListSafe = Array.isArray(checkedList) ? checkedList : [];
          const searchStr = String(searchText ?? "").toLowerCase();

          const isActive = checkedListSafe.length > 0 || searchStr !== "";
          if (!isActive) return true;

          if (cellData === undefined || cellData === null || cellData === "")
            return false;

          const cellStr =
            typeof cellData === "boolean"
              ? cellData
                ? "true"
                : "false"
              : String(cellData);

          const dataStr = cellStr.toLowerCase();

          return searchStr !== "" && checkedListSafe.length > 0
            ? checkedListSafe.includes(cellStr) && dataStr.includes(searchStr)
            : checkedListSafe.length > 0
            ? checkedListSafe.includes(cellStr)
            : dataStr.includes(searchStr);
        }

        case "between": {
          const selectedVal: any[] = filter.value;

          if (
            !Array.isArray(selectedVal) ||
            selectedVal.length < 2 ||
            !selectedVal[0] ||
            !selectedVal[1]
          ) {
            return true;
          }

          if (_colProp.type === "date" || _colProp.type === "datetime") {
            if (!cellData) return false;

            let rowData = moment(
              cellData,
              [moment.ISO_8601, "DD/MM/YYYY", "DD MMM YYYY", "D MMM YYYY"],
              "th",
              true
            );

            if (!rowData.isValid()) return false;

            if (rowData.year() > 2400) {
              rowData = rowData.subtract(543, "years");
            }

            if (_colProp.type === "date") {
              rowData = rowData.clone().add(1, "seconds");
            }

            return rowData.isBetween(
              selectedVal[0].startOf("day"),
              selectedVal[1].endOf("day"),
              undefined,
              "[]"
            );
          }

          if (cellData === undefined || cellData === null) return false;

          const recordVal = Number(
            typeof cellData === "string"
              ? cellData.replaceAll(",", "")
              : cellData
          );

          if (Number.isNaN(recordVal)) return false;

          const min = Number(selectedVal[0]);
          const max = Number(selectedVal[1]);

          return recordVal >= min && recordVal <= max;
        }

        default:
          return true;
      }
    });
  });
};

export const checkedForDataTypes = (
  dataKeys: string[],
  dataSource: any[],
  masterFormat?: string
) => {
  
  let keyTypes: ColumnsProps[] = [];
  let foundKeys: Set<string> = new Set();
  
  let validKeys = dataKeys.filter((key) => {
    return dataSource.some((row) => row[key] !== null);
  });
  
  for (let i = 0; i < dataSource.length; i++) {
    for (let key of dataKeys) {
      let dataType = "string";

      if (["createddate", "modifieddate"].includes(key.toLowerCase())) {
        dataType = "datetime";
      } else if (key.toLowerCase().includes("date")) {
        dataType = "date";
      }
      const option =
        dataType !== "object"
          ? Array.from(new Set(dataSource?.map((e) => e[key]))).map((e) => {
              return e?.toString();
            })
          : [];

      if (!foundKeys.has(key)) {
        
        keyTypes.push({
          key: key,
          label: key,
          option: !["date", "datetime"].includes(dataType) ? option : [],
          type: dataType,
          dateFormat:
            dataType === "date" || dataType === "datetime"
              ? masterFormat
              : undefined,
        });
        
        foundKeys.add(key);
      }
    }
    if (foundKeys.size === validKeys.length) {
      break;
    }
  }
  
  return keyTypes;
};

export const formatData = async (
  dataSource: any[],
  dataKey: ColumnsProps[]
) => {
  let newData = dataSource;
  dataKey.forEach((colProp) => {
    if (["date", "datetime"].includes(colProp.type.toLowerCase())) {
      newData.forEach((e: any) => {
        const originalDate = moment(e[colProp.key]);
        const formatStr = "D MMM yyyy";

        e[colProp.key] = toBuddhistYear(originalDate, formatStr);
      });
    }
  });
  return newData;
};

export const toBuddhistYear = (moment: Moment, format: string) => {
  var christianYear = moment.format("YYYY");
  var buddhishYear =
    parseInt(christianYear) <= 2500
      ? (parseInt(christianYear) + 543).toString()
      : parseInt(christianYear).toString();
  return moment
    .format(
      format
        .replace("YYYY", buddhishYear)
        .replace("YY", buddhishYear.substring(2, 4))
    )
    .replace(christianYear, buddhishYear);
};

export const getColumnSearchProps2 = (
  options: ColumnFilterElementTemplateOptions,
  colProp: ColumnsProps,
  originalData: any[],
  allColumnProps: ColumnsProps[],
  filtersState: any
) => {
  const stripCurrentFilter = (filters: any, currentKey: string) => {
    const newFilters: any = {};
    Object.keys(filters || {}).forEach((key) => {
      if (key !== currentKey) {
        newFilters[key] = filters[key];
      }
    });
    return newFilters;
  };

  const optionData = filterData(
    originalData,
    stripCurrentFilter(filtersState, colProp.key),
    allColumnProps
  );

  if (colProp.type === "date" || colProp.type === "datetime") {
    return (
      <DataFilterComponent
        colProp={colProp}
        options={options}
        filtersState={filtersState}
        allColumnProps={allColumnProps}
        dataSource={originalData}
      />
    );
  }

  if (colProp.type === "number") {
    return (
      <NumberFilterComponent
        colProp={colProp}
        options={options}
        filtersState={filtersState}
        allColumnProps={allColumnProps}
        dataSource={originalData}
      />
    );
  }

  if (colProp.type === "string") {
    return (
      <StringFilterComponent
        colProp={colProp}
        options={options}
        filtersState={filtersState}
        allColumnProps={allColumnProps}
        dataSource={optionData}
      />
    );
  }

  return <></>;
};
